import {getPost} from "../../js/api/restAPI";
import {sweetAlert} from "../../js/alert/sweetAlert";

const mainCategory = {
    namespaced: true,
    state: {
        categories: [],
    },
    getters: {
        get(state) {
            return state.categories;
        },
        filter: (state) => (code) => {
            return state.categories.find(cat => cat.code === code);
        }
    },
    mutations: {
        set(state, data) {
            state.categories = data;
        }
    }
    ,
    actions: {
        async fetch({commit}) {
            await getPost('getMainCategories', null)
                .then(function (response) {
                    if (response.data.code !== 200) {
                        sweetAlert('error', response.data.description)

                    } else {
                        commit("set", response.data.data.mainCategories);
                    }
                }).catch(function (error) {
                    sweetAlert('error', error)
                })
        }
    }
}


export default mainCategory